import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { AuthProvider } from './context/AuthContext'
import { AppProvider } from './context/AppContext'
import { captureUtmAndVariant } from './utils/metaPixel'
import './index.css'
import faviconSrc from './assets/merlin-hat.png'

// Capture UTM + variant A/B AVANT que React monte. Persiste en localStorage
// pour que tous les events studio_funnel suivants soient enrichis avec
// l'attribution source (adset Meta) + le variant test.
captureUtmAndVariant()

// HOTFIX 04/08 : drapeaux d'offres (deal -80%, membre -45%) persistés ICI,
// AVANT React et toute navigation. Avant, le flag n'était posé que si un
// paywall rendait pendant que le param était encore dans l'URL : le cliqueur
// du mail naviguait (scan, connexion), le param disparaissait, et il voyait
// le tarif standard 89€/essai au lieu de son offre. Retours clients « le
// tarif n'est pas le bon » = ce bug.
try {
  const q = new URLSearchParams(window.location.search)
  if (q.get('deal') === '1') localStorage.setItem('studio_deal_offer', '1')
  if (q.get('deal') === '0') localStorage.removeItem('studio_deal_offer')
  const promo = q.get('promo')
  if (promo === 'membre' || promo === 'member') localStorage.setItem('studio_member_offer', '1')
  if (promo === '0') localStorage.removeItem('studio_member_offer')
  // A/B/C structure de facturation (06/08) piloté par le LIEN d'adset Meta :
  // A (rien/?offre=essai) = normal avec essai 7j · B (?offre=annuel ou
  // ?deal=1) = offre unique deal annuel -80% · C (?offre=direct) = tarifs
  // normaux SANS essai, satisfait ou remboursé 14j. Persisté avant React.
  const offre = (q.get('offre') || '').toLowerCase()
  if (offre === 'annuel' || offre === 'annual' || offre === 'deal') localStorage.setItem('studio_deal_offer', '1')
  if (offre === 'direct' || offre === 'sansessai') localStorage.setItem('studio_offer_arm', 'C')
  if (offre === 'essai' || offre === '0') { localStorage.removeItem('studio_offer_arm'); localStorage.removeItem('studio_deal_offer') }
} catch { /* best effort */ }

// HOTFIX 2026-06-26 : un mailing systeme.io est parti avec le MAUVAIS lien
// format (Otai e57aa72c au lieu de la video cuisine 22a24049). Comme l'email
// est fige, on rattrape cote client : tout visiteur arrivant sur la fiche Otai
// AVEC le tag de ce mailing (utm_source=systemeio) est renvoye vers la bonne
// fiche, en conservant l'attribution. Surgical : n'affecte que ce mailing.
try {
  const BAD = '/format/e57aa72c-fdeb-443b-b606-5f31feb17890'
  const GOOD = '/format/22a24049-4022-42fc-a301-81bae6155616'
  const path = window.location.pathname.replace(/\/$/, '')
  const sp = new URLSearchParams(window.location.search)
  if (path === BAD && sp.get('utm_source') === 'systemeio') {
    window.location.replace(GOOD + '?' + sp.toString())
  }
} catch { /* noop */ }

// Détecte le cas où l'OAuth Studio a fallback vers Merlin (whitelist
// Supabase mal configurée). Si oui, rebondit vers Studio AVANT que React +
// AuthProvider montent, sinon Supabase JS consommerait le token/code sur
// Merlin et on perdrait la session côté studio.* (localStorage scopé par origin).
//
// Gère les 2 flux OAuth Supabase :
//   - implicit : token en URL hash (#access_token=...)
//   - PKCE     : code en query string (?code=...) — défaut sur Supabase JS v2.45+
function shouldBounceOAuthToStudio() {
  try {
    if (typeof window === 'undefined') return false
    const host = window.location.hostname
    if (host.startsWith('studio.')) return false
    if (!host.endsWith('merlin-content-ai.com')) return false
    const hasIntent = document.cookie.split(';').some(c => c.trim().startsWith('studio_oauth_intent=1'))
    if (!hasIntent) return false
    const hash = window.location.hash || ''
    const search = window.location.search || ''
    const hasImplicitToken = hash.includes('access_token=')
    const hasPkceCode = /[?&]code=/.test(search)
    if (!hasImplicitToken && !hasPkceCode) return false
    return true
  } catch { return false }
}

// STUDIO PAR DÉFAUT (décision Antonin 27/07, retour user jordan77g : « pourquoi
// une version Studio ET une version normale ? »). L'ancien Merlin ressortait sur
// le domaine de base + l'URL Railway brute et semait la confusion (comptes/abos
// distincts). On redirige TOUT le trafic SPA de ces hôtes vers Studio, SAUF :
//   - /format/:id et /blog (pages SEO publiques, indexées — ne jamais casser)
//   - /admin (le panel admin, aussi dispo sur studio.*)
//   - les fichiers statiques (.html/.xml/.txt/assets)
//   - ?studio=0 (échappatoire explicite vers l'ancien Merlin, ex : test/support)
// NB : localhost/dev ne matchent pas -> aucun effet en local.
function shouldRedirectToStudio() {
  try {
    if (typeof window === 'undefined') return false
    const h = window.location.hostname.toLowerCase()
    if (h.startsWith('studio.')) return false
    const isLegacyHost = h === 'merlin-content-ai.com' || h === 'www.merlin-content-ai.com' || h.endsWith('.up.railway.app')
    if (!isLegacyHost) return false
    const path = window.location.pathname || '/'
    if (/^\/(format|blog|admin|compte|video)\b/i.test(path)) return false
    if (/\.[a-z0-9]{2,5}$/i.test(path)) return false // fichier statique (.html, .xml, .png, .js…)
    if (new URLSearchParams(window.location.search).get('studio') === '0') return false
    return true
  } catch { return false }
}

// Dynamic favicon with environment-based color tinting
;(function setFavicon() {
  const isDev = import.meta.env.VITE_APP_ENV === 'dev'
  const img = new Image()
  img.crossOrigin = 'anonymous'
  img.onload = () => {
    const c = document.createElement('canvas')
    c.width = 64; c.height = 64
    const ctx = c.getContext('2d')
    ctx.drawImage(img, 0, 0, 64, 64)
    // Apply color tint
    ctx.globalCompositeOperation = 'source-atop'
    ctx.fillStyle = isDev ? '#f97316' : '#3b82f6' // orange dev, blue prod
    ctx.globalAlpha = 0.6
    ctx.fillRect(0, 0, 64, 64)
    // Set favicon
    let link = document.querySelector("link[rel='icon']")
    if (!link) { link = document.createElement('link'); link.rel = 'icon'; document.head.appendChild(link) }
    link.href = c.toDataURL('image/png')
  }
  img.src = faviconSrc
})()

// Error boundary
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          color: '#dc3545', padding: '40px', fontFamily: 'DM Mono, monospace',
          fontSize: '12px', whiteSpace: 'pre-wrap', background: '#fcfdfa',
          border: '2px solid #dc3545', margin: '20px', borderRadius: '6px',
        }}>
          {'ERREUR:\n' + String(this.state.error?.message || this.state.error) + '\n\n' + String(this.state.error?.stack || '')}
        </div>
      )
    }
    return this.props.children
  }
}

// ?reset=1 : nuke localStorage + sessionStorage + cookies puis redirige
// vers l'origin propre. Pratique pour test fresh user en local et en prod.
function shouldResetSession() {
  try {
    if (typeof window === 'undefined') return false
    return new URLSearchParams(window.location.search).get('reset') === '1'
  } catch { return false }
}

if (shouldResetSession()) {
  try {
    localStorage.clear()
    sessionStorage.clear()
    document.cookie.split(';').forEach(c => {
      const name = c.split('=')[0].trim()
      if (!name) return
      const expire = 'Thu, 01 Jan 1970 00:00:00 GMT'
      document.cookie = `${name}=; expires=${expire}; path=/`
      document.cookie = `${name}=; expires=${expire}; path=/; domain=.merlin-content-ai.com`
      document.cookie = `${name}=; expires=${expire}; path=/; domain=${window.location.hostname}`
    })
  } catch {}
  document.getElementById('root').innerHTML =
    '<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;font-family:DM Sans,sans-serif;color:#7c3aed;font-size:14px;">Reset session, redirection…</div>'
  window.location.replace(window.location.origin)
} else if (shouldBounceOAuthToStudio()) {
  // OAuth (hash implicit OU code PKCE) → on rebondit vers Studio AVANT que
  // Supabase JS l'avale sur le mauvais domaine.
  document.cookie = 'studio_oauth_intent=; domain=.merlin-content-ai.com; path=/; max-age=0; samesite=lax; secure'
  document.getElementById('root').innerHTML =
    '<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;font-family:DM Sans,sans-serif;color:#7c3aed;">Redirection vers Studio…</div>'
  const search = window.location.search || ''
  const hash = window.location.hash || ''
  window.location.replace('https://studio.merlin-content-ai.com/' + search + hash)
} else if (shouldRedirectToStudio()) {
  // Studio par défaut : l'ancien Merlin ne doit plus ressortir. On garde la
  // query (UTM/claim) et le hash, on repart sur la racine Studio (les routes
  // legacy /strategy /library n'existent pas côté Studio).
  document.getElementById('root').innerHTML =
    '<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;font-family:DM Sans,sans-serif;color:#7c3aed;">Redirection vers Studio…</div>'
  const search = window.location.search || ''
  const hash = window.location.hash || ''
  window.location.replace('https://studio.merlin-content-ai.com/' + search + hash)
} else {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <ErrorBoundary>
      <AuthProvider>
        <AppProvider>
          <App />
        </AppProvider>
      </AuthProvider>
    </ErrorBoundary>
  )
}
